import React from 'react';

import Content from '../components/circle-content';
import Faq from '../components/franchise/faq';
import Form from '../components/franchise/form';

export default ({ copy }) => {
	return (
		<>
			<Content data={copy.content} />
			<Faq data={copy.faq} />
			<Form data={copy.form} />
		</>
	);
};
